export enum LegalEntityType {
    SoleProprietorships = 0,
    Partnerships = 1,
    CCorporations = 2,
    SCorporations = 3,
    LimitedLiabilityCompany = 4,
}

export const LegalEntityTypeList = [
    {
        id: LegalEntityType.SoleProprietorships,
        name: 'Sole Proprietorships',
        abbreviation: 'SP',
    },
    {
        id: LegalEntityType.Partnerships,
        name: 'Partnerships',
        abbreviation: 'Partnership',
    },
    {
        id: LegalEntityType.CCorporations,
        name: 'C-Corporations',
        abbreviation: 'C-Corp',
    },
    {
        id: LegalEntityType.SCorporations,
        name: 'S-Corporations',
        abbreviation: 'S-Corp',
    },
    {
        id: LegalEntityType.LimitedLiabilityCompany,
        name: 'Limited liability company (LLC)',
        abbreviation: 'LLC',
    },
];

export const LegalEntityTypeOptions = {
    [LegalEntityType.SoleProprietorships]: 'Sole Proprietorships',
    [LegalEntityType.Partnerships]: 'Partnerships',
    [LegalEntityType.CCorporations]: 'C-Corporations',
    [LegalEntityType.SCorporations]: 'S-Corporations',
    [LegalEntityType.LimitedLiabilityCompany]:
        'Limited liability company (LLC)',
};
